import React from 'react';
import { UtensilsCrossed, X, Save, Loader2, Info } from 'lucide-react';
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { MODAL_OVERLAY_Z40_CLASS } from '../../ui/modalOverlay';
import { formatDateForDisplay } from '../cantineUtils';

const ModalMenuJour = ({ isOpen, onClose, date, value, setValue, isSaving, onSubmit }) => {
  if (!isOpen || !date) return null;

  const aDuContenu = Boolean(
    (value.entree || '').trim() || (value.plat || '').trim() || (value.dessert || '').trim()
  );

  return (
    <div className={`${MODAL_OVERLAY_Z40_CLASS} flex items-center justify-center p-4`}>
      <div className="bg-white rounded-lg shadow-2xl max-w-xl w-full max-h-[92vh] overflow-y-auto">
        <div className="bg-[#319190] p-6 flex items-center justify-between sticky top-0 z-10">
          <div>
            <p className="text-xs font-semibold uppercase tracking-wide text-white/80">Menu de la cantine</p>
            <h3 className="text-xl font-semibold text-white flex items-center gap-3">
              <UtensilsCrossed size={24} />
              Menu du jour
            </h3>
            <p className="text-sm text-white/90 mt-1 capitalize">{formatDateForDisplay(date)}</p>
          </div>
          <button
            onClick={onClose}
            className="text-white hover:bg-white/20 rounded-lg p-2 transition-colors"
            disabled={isSaving}
          >
            <X size={22} />
          </button>
        </div>

        <div className="p-6 space-y-5">
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 flex items-start gap-3">
            <Info size={18} className="text-blue-600 mt-0.5 flex-shrink-0" />
            <p className="text-sm text-blue-900">
              Ce menu s'affichera sur la <strong>feuille de pointage</strong> de cette journée, pour que
              l'équipe l'ait sous les yeux au moment du service.
            </p>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Entrée</label>
            <Input
              placeholder="Ex : salade de crudités"
              value={value.entree || ''}
              onChange={(e) => setValue({ ...value, entree: e.target.value })}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Plat principal</label>
            <Input
              placeholder="Ex : poulet aux légumes, riz"
              value={value.plat || ''}
              onChange={(e) => setValue({ ...value, plat: e.target.value })}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Dessert</label>
            <Input
              placeholder="Ex : fruit de saison"
              value={value.dessert || ''}
              onChange={(e) => setValue({ ...value, dessert: e.target.value })}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Note interne (optionnelle)</label>
            <textarea
              value={value.observations || ''}
              onChange={(e) => setValue({ ...value, observations: e.target.value })}
              placeholder="Variante pour les régimes particuliers, remarque pour l'équipe..."
              rows={2}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#319190] focus:border-transparent"
            />
          </div>

          <div className="flex gap-3 pt-4 border-t">
            <Button variant="outline" size="default" className="flex-1" onClick={onClose} disabled={isSaving}>
              Annuler
            </Button>
            <Button
              size="default"
              className="flex-1 bg-[#319190] hover:bg-[#277a79] text-white"
              onClick={onSubmit}
              disabled={isSaving || !aDuContenu}
            >
              {isSaving ? (
                <>
                  <Loader2 size={16} className="mr-2 animate-spin" />
                  Enregistrement...
                </>
              ) : (
                <>
                  <Save size={16} className="mr-2" />
                  Enregistrer le menu
                </>
              )}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalMenuJour;
